import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { useStore } from '../../../../hooks/useStore';
import CreateCustomBenefitStore from '../store/createCustomBenefitStore';

const store = new CreateCustomBenefitStore();
const CreateCustomBenefitContext = createContext(store);

export const CreateCustomBenefitContextProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <CreateCustomBenefitContext.Provider value={store}>
      {children}
    </CreateCustomBenefitContext.Provider>
  );
};

export const useCreateCustomBenefit = () => {
  const { companyStore } = useStore();
  const newCustomBenefit = useContext(CreateCustomBenefitContext);

  const createCustomBenefit = async () => {
    const request = await newCustomBenefit.buildCustomBenefitRequest();
    if (!request) throw new Error('Custom benefit is incomplete, no request was sent');
    return companyStore.createCustomBenefit(request);
  };

  const patchCustomBenefit = async (benefitId: string) => {
    const request = await newCustomBenefit.buildCustomBenefitPatchRequest();
    if (!request) throw new Error('Custom benefit is incomplete, no request was sent');
    return companyStore.patchCustomBenefit(request, benefitId);
  };

  return {
    newCustomBenefit,
    createCustomBenefit,
    patchCustomBenefit
  };
};
